import React, { useEffect, useState } from "react";
import { ImageProps } from "@/types/modules/post/contentComponents";
import { PostLightboxImage } from "@/components/modules/Post/Content/PostLightboxImage";
import { PostGalleryLink } from "@/components/modules/Post/Content/PostGalleryLink";
import { useOfflineImageContent } from "@/hooks/indexeddb/useOfflineImageContent";

export const PostImage: React.FC<ImageProps> = ({
  source,
  authorName,
  caption,
  src,
  post,
  allImageSources,
  priority,
  disableImgLazyLoading,
}) => {
  const [offlineThumbnailBlob, setOfflineThumbnailBlob] = useState<string>();
  const { loadOfflineImage } = useOfflineImageContent();

  useEffect(() => {
    if (src) {
      loadOfflineImage(src).then((offlinePostThumbnail) => {
        if (offlinePostThumbnail) {
          setOfflineThumbnailBlob(offlinePostThumbnail);
        }
      });
    }
  }, [src, loadOfflineImage]);

  return (
    <div className="mb-6 w-full md:mb-8">
      <figure className="w-full">
        <PostLightboxImage
          priority={priority ?? false}
          imageSource={offlineThumbnailBlob ?? src}
          alt={caption}
          allImageSources={allImageSources}
          disableImgLazyLoading={disableImgLazyLoading}
        />
        {(caption || source || authorName) && (
          <figcaption className="mt-2 !px-0 font-sans text-2xs text-dark-70 dark:text-white sm:text-md">
            {caption}
            {(source || authorName) && (
              <p className="mt-2 font-sans text-xsDescription font-light text-dark-70 dark:text-white-70">
                {authorName || source}
              </p>
            )}
          </figcaption>
        )}
      </figure>
      {!!post?.galleryCount && post?.hasGallery && (
        <div className="mt-3">
          <PostGalleryLink galleryCount={post?.galleryCount} postId={post?.id} postSlug={post?.slug} />
        </div>
      )}
    </div>
  );
};
